( function() {
	const stickyBar = document.querySelector( '.facility-details__sticky' );
	if( !stickyBar ) { return; }

	const contactInfo = document.querySelector( '.facility-details__contact-info' );
	const ACTIVE = 'facility-details__sticky--active';
	const UNSTUCK = 'facility-details__sticky--unstuck';

	const observer = new IntersectionObserver( function( entries ) {
		entries.forEach( function( entry ) {
			if( entry.target === contactInfo ) {
				if( entry.isIntersecting ) { // contact info in view
					stickyBar.classList.add( UNSTUCK );
					if( !inViewport( stickyBar ) ) {
						// the page is long enough it can be sticky naturally
						stickyBar.classList.remove( UNSTUCK );
					}

					stickyBar.classList.remove( ACTIVE );
				} else {
					stickyBar.classList.add( ACTIVE );
				}
			}
		} );
	}, { threshold: .5 } ); // when 50% of it is visible

	observer.observe( contactInfo );

	// https://stackoverflow.com/a/12418814/738394
	function inViewport( element ) {
		if( !element ) return false;
		if( 1 !== element.nodeType ) return false;

		var html = document.documentElement;
		var rect = element.getBoundingClientRect();

		return !!rect &&
			rect.bottom >= 0 &&
			rect.right >= 0 && 
			rect.left <= html.clientWidth &&
			rect.top <= html.clientHeight;
	}
} )();